var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"app"}},[_c('Navbar'),_c('v-main',[_c('KeepAlive',{attrs:{"exclude":['OneBlockage', 'OrderDetail']}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }